import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals'; // Removed to reduce bundle size
import { QueryClient, QueryClientProvider, keepPreviousData } from "@tanstack/react-query";
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createIDBPersister } from './utils/persister';
import LoadingPage from './components/LoadingPage';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // Cached data is fresh for 1 minute - shows immediately
      gcTime: 1000 * 60 * 60 * 24 * 30, // 30 days cache for offline
      refetchOnWindowFocus: true, // Check for updates when returning to app
      refetchOnMount: true, // Check for updates on component mount
      retry: 1, // Minimize retries when offline
      networkMode: 'offlineFirst', // Use cache when offline
      placeholderData: keepPreviousData,
    },
  },
});

const persister = createIDBPersister();

root.render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 1000 * 60 * 60 * 24 * 30, // 30 days
      }}
      onSuccess={() => console.log("Cache restored from IndexedDB")}
    >
      <App />
    </PersistQueryClientProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// Auto-reload is now handled by UpdateBanner component (user gets a prompt first)

// Performance monitoring disabled to reduce bundle size
// To enable: npm install web-vitals, import reportWebVitals, and call reportWebVitals(console.log)
